import { useState, useCallback } from 'react';
import { fetchMyGamics } from '@/store/Gamic';
import { fetchMyAudience } from '@/store/Campaign';
import { fetchCards } from '@/store/Payment';

export const useCampaignFetchData = (dispatch: any) => {
  const [games, setGames] = useState([]);
  const [audiences, setAudiences] = useState([]);

  const fetchAllData = useCallback(async () => {
    const gamicRes = await dispatch(fetchMyGamics({ limit: 1000, status: 'approved' }));
    const audRes = await dispatch(fetchMyAudience({ limit: 1000 }));

    setGames(gamicRes.payload.data);
    setAudiences(audRes.payload.data);
  }, [dispatch]);

  return {
    games,
    audiences,
    fetchAllData,
  };
};